import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={24.542}
    height={25.701}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 78802 82524"
    {...props}
  >
    <path
      d="M78769 41831 58574 21634C54051 8353 46892 1956 34649 254 18632-1978 4711 10940 1004 24186c-2085 7446-897 15674 3347 23169 4968 8774 13674 15498 23983 18552v9683h-5094s-9684 866-9684 6934h31901c0-6068-9685-6934-9685-6934h-5101V64134l-860-236c-10087-2766-18627-9215-23426-17695-3935-6950-5046-14546-3131-21388C6712 12465 20029 581 34327 2568c11232 1563 17598 7171 21852 19293L36210 41831c-66 66-19 182 76 182h42409c94 0 142-116 74-182z"
      style={{
        fill: "#231f20",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
